import { render, staticRenderFns } from "./ApplicantsView.vue?vue&type=template&id=bcff2f5c"
import script from "./ApplicantsView.vue?vue&type=script&lang=js"
export * from "./ApplicantsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports